'use strict'

GrouponMaps = require 'grpn-maps/lib/client/index'
paginationHelper = require '../../pagination/common/helpers'
spinnerGroup = require '../../page/frontend/helpers/spinner_group'
PullMapsCollectionsDealCardMarkers = require './collections/deal_card_markers'
domConfig = require '../../page/frontend/helpers/dom_config'
hiddenCards = require '../../page/frontend/helpers/initiallyHiddenCards'
jsLazyLoader = require '../../page/frontend/helpers/js_lazy_loader'
CardUI = require 'grpn-card-ui/frontend/init_render'

DYNAMIC_MAP_EL = '#pull-dynamic-map'
STATIC_MAP_EL = '#pull-static-map'
STATIC_MAP_WRAPPER_EL = '#pull-static-map-wrapper'
MAP_CARD = '#pull-dynamic-map .overlay-container .card-ui'
MAP_BUTTON_EL = '.pull-map-button'

MARKER_CONFIG =
  default:
    template:
      render: (context) ->
        PullMapsApplication.renderOverlayTemplate(context)

DYNAMIC_OPTIONS =
  markerConfig: MARKER_CONFIG
  el: DYNAMIC_MAP_EL
  isStatic: false
  dimensions:
    height: 350
  controls:
    zoom: true
    toggle: true

DYNAMIC_MAP_LOAD_DATA_PER_PAGE = domConfig.get().Maps.numberPagesCardsOnMap

STATIC_OPTIONS =
  markerConfig: MARKER_CONFIG
  el: STATIC_MAP_EL
  isStatic: true
  dimensions:
    width: 335
    height: 312
  controls:
    zoom: false
    toggle: false

GrouponMaps.prototype.onError = (err) -> PullMapsApplication.onError(err)

PullMapsApplication = _.extend {}, Backbone.Events,
  initialize: (@desktopApplication) ->
    @controlsBound = false
    @isDynamic = false
    @map = new GrouponMaps @_buildMapOptions()
    @onError(@queuedStaticMapError) if @queuedStaticMapError?

    @previousPageNumber = undefined

    return unless @_dynamicMapElementExists()

    @collection = @_getCollection()
    @_addListeners()

    if @_shouldRenderDynamicMap()
      @update()
      $(MAP_BUTTON_EL).addClass('active')
      $(STATIC_MAP_WRAPPER_EL).hide()
      $(DYNAMIC_MAP_EL).show()
    else
      @_bindControls()
      $(MAP_BUTTON_EL).removeClass('active')
      $(STATIC_MAP_WRAPPER_EL).show()
      $(DYNAMIC_MAP_EL).hide()

    $(MAP_BUTTON_EL).on 'click', =>
      @toggle()

    this

  onError: (err) ->
    return @queuedStaticMapError = err unless @map
    @map.showErrorView err
    $(DYNAMIC_MAP_EL).height 'auto'

  update: (xhrParams) ->
    xhrParams ?= @_getXhrParams()
    return unless @_needUpdate(xhrParams.page)

    @fetchingData = true

    spinnerGroup.start 'map',
      el: DYNAMIC_MAP_EL
      topMargin: '55px'

    @collection.fetch
      data: xhrParams
      reset: true

  markUpdated: ->
    @hasNewlyUpdatedDeals = true

  toggle: ->
    isStatic = @_isStatic()
    @_setAsStatic() unless isStatic
    @_setAsDynamic() if isStatic
    OptimizeSuite.treatAsNewPage(window.location.href)

  renderOverlayTemplate: (context) ->
    CardUI.renderCard(context.card)

  onRefine: ->
    @previousPageNumber = undefined

  reCenterDynamicMap: ->
    @map.centerPosition() if @isDynamic

  _getCollection: ->
    new PullMapsCollectionsDealCardMarkers()

  _addListeners: ->
    @on 'refinedResults', =>
      @onRefine()
      @update()

    @listenTo @map, 'click:toggle', @toggle
    @listenTo @collection, 'error', @onError
    @listenTo @collection, 'newPageBlock', @update
    @listenTo @collection, 'visibleMarkersUpdated', =>
      @_updateData() unless @_isStatic()

    @listenTo @map, 'markerCardDisplayed', ->
      GIG.Utils.truncateElements($(MAP_CARD))

    @listenTo @collection, 'sync', =>
      @fetchingData = false
      _.defer =>
        @_updateData()
        spinnerGroup.stop 'map'

  _bindControls: ->
    unless @controlsBound
      $(STATIC_MAP_WRAPPER_EL).on 'click', =>
        @_setAsDynamic()
      @controlsBound = true

  _getPos: ->
    domConfig.get()?.division?.ell or {lat: 0, lng: 0}

  _staticMapElementExists: ->
    $(STATIC_MAP_EL).length != 0

  _dynamicMapElementExists: ->
    $(DYNAMIC_MAP_EL).length != 0

  _shouldRenderDynamicMap: ->
    ($('pull-map-button').length != 0 || @_staticMapElementExists()) && @_dynamicMapElementExists() && !@_isStatic()

  _updateData: ->
    @map.set('data', @collection.toJSON(), false, true)

  _buildMapOptions: (isStatic) ->
    isStatic ?= @_isStatic()

    options = _.extend {}, STATIC_OPTIONS if isStatic
    options = _.extend {}, DYNAMIC_OPTIONS unless isStatic
    options.data = @collection.toJSON() if @collection
    options.position = @_getPos()
    options.pageConfig = domConfig.get().Maps

    @isDynamic = not isStatic

    if @isDynamic
      options.controls.myLocation = true

    options

  _setAsStatic: ->
    $(MAP_BUTTON_EL).removeClass('active')
    @_bindControls()
    $(DYNAMIC_MAP_EL).hide()
    $(STATIC_MAP_WRAPPER_EL).show()
    $('.cui-c-udc.cui-udc-hidden').hide()
    @map.set @_buildMapOptions(true)
    hiddenCards.adjustOrphanDeal()

  _setAsDynamic: ->
    $(MAP_BUTTON_EL).addClass('active')
    $(STATIC_MAP_WRAPPER_EL).hide()
    $('.cui-c-udc.cui-udc-hidden').hide()
    $(DYNAMIC_MAP_EL).show()

    jsLazyLoader.load domConfig.get().cardUIRendererUrl

    @map.set @_buildMapOptions(false)

    if @hasNewlyUpdatedDeals or !(@fetchingData or @collection.length)
      @hasNewlyUpdatedDeals = false
      @update()

    hiddenCards.adjustOrphanDeal()

  _isStatic: ->
    if domConfig.get()?.enabledFeatures?.showMap
      return not @isDynamic
    false

  _getXhrParams: ->
    # Band-Aid®
    # Params should be passed INTO this application by the Search App.
    @desktopApplication.xhrParams

  _needUpdate: (PageNumber = 1) ->
    previousPageNumber = @previousPageNumber
    currentPageNumber = parseInt PageNumber, 10
    @previousPageNumber = currentPageNumber
    return true unless previousPageNumber?
    not paginationHelper.isSamePageBlock(previousPageNumber, currentPageNumber, DYNAMIC_MAP_LOAD_DATA_PER_PAGE)

module.exports = window.PullMapsApplication = PullMapsApplication
